/**
 * @generated SignedSource<<a384df2f439b3c33d460f99a9ec251f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalWorkItemSubtype = "APPROVAL" | "BUG" | "CATALOG_ITEM" | "DEFAULT_TASK" | "EPIC" | "INCIDENT" | "ISSUE" | "MILESTONE" | "OTHER" | "PROBLEM" | "QUESTION" | "REQUESTED_ITEM" | "SECTION" | "STORY" | "TASK" | "TICKET" | "WORK_ITEM" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphWorkItem_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly assignee?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly dueDate?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly subtype?: ExternalWorkItemSubtype | null | undefined;
    readonly workItemProject?: {
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphWorkItem_AtlassianSearchPage";
};
export type searchGraphWorkItem_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphWorkItem_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphWorkItem_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "name": "name"
  }
],
v5 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": (v4/*: any*/)
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "subtype"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphWorkItem_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v5/*: any*/)
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": (v5/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "dueDate"
            },
            {
              "concreteType": "ExternalWorkItemProject",
              "kind": "LinkedField",
              "name": "workItemProject",
              "plural": false,
              "selections": (v4/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "status"
            },
            (v6/*: any*/)
          ],
          "type": "ExternalWorkItem"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "9dd7e6601b2284205ebc495ea9885d2d";

export default node;
